
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradient","x1":".5","x2":".5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#9680f1"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#605bf8"}})])]),_c('g',{attrs:{"id":"tool","transform":"translate(-741.02 -190.764)"}},[_c('circle',{attrs:{"id":"Ellipse_442","data-name":"Ellipse 442","cx":"10","cy":"10","r":"10","transform":"translate(741.02 190.764)","fill":"url(#linear-gradient)"}}),_c('path',{attrs:{"id":"Path_20612","data-name":"Path 20612","d":"M3.967.771A1.755 1.755 0 015.735.008 1.521 1.521 0 016.82.771l3.7 6.016a1.777 1.777 0 01.113 1.537A1.581 1.581 0 019.1 9.339H1.7a1.761 1.761 0 01-1.5-.907 1.559 1.559 0 01.065-1.646z","transform":"rotate(90 280.476 475.865)","fill":"#fff"}})])])
          )
        }
      }
    